import { UpdateCollectionBodyParams, UserResponse } from "@authory-packages/core";
import { assign, pickBy } from "lodash";
import { QueryClient } from "@tanstack/react-query";
import { getAuthenticatedUserQuerie } from "../../../types/queries";

export const onCollectionOptimisticUpdate = (
    token: string | null,
    queryClient: QueryClient,
    params: UpdateCollectionBodyParams,
    collectionId: string
) => {
    // Snapshot the previous value
    const oldUser = queryClient.getQueryData<UserResponse>(getAuthenticatedUserQuerie(token));

    //remove undefined properties or other crap
    const cleanParams = pickBy(params, (val) => val !== undefined);

    // Generate new user
    const newUser = assign({}, oldUser, {
        collections: oldUser?.collections.map((col) => (col.canonicalSlug !== collectionId ? col : assign({}, col, cleanParams)))
    }) as UserResponse;

    // Optimistically update to the new value
    queryClient.setQueryData(getAuthenticatedUserQuerie(token), newUser);

    // Return the snapshotted value
    return oldUser;
};
